import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as R from 'ramda'

import Clock from 'components/form/clock/index'
import { createNamedReducer } from 'helpers/ReducerUtil'
import { createNamedAction } from 'helpers/ActionUtil'
import clockReducer from './reducer'
import injectReducer from 'helpers/injectReducer'
import getSelectors, { getValueSelector } from './selectors'
import {
  UPDATE_VALUE
} from './constants'
import {
  updateValue
} from './actions'
import {
  getPath,
  combinePath
} from 'containers/Form/util'
import withValidation from 'containers/Form/Util/Risk/riskProperty'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const reducer = createNamedReducer(valuePath, clockReducer)
  return injectReducer(valuePath, reducer)
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const updateValueAction = createNamedAction(valuePath, updateValue)
  const {
    ocBinValueSelector,
    baseValueSelector,
    boostValueSelector,
    offsetValueSelector,
    tgpValueSelector,
    overclockValueSelector,
    sourcesSelector,
    baseSourcesSelector,
    ocBinSourcesSelector,
    boostSourcesSelector,
    tgpSourcesSelectors,
    offsetSourcesSelector,
    overclockSourcesSelector,
    minBoostSelector,
    maxBoostSelector,
  } = getSelectors(combinedPath)

  const mapStateToProps = (state) => {
    return {
      ocBin: ocBinValueSelector(state),
      minBoost: minBoostSelector(state),
      maxBoost: maxBoostSelector(state),
      baseValue: baseValueSelector(state),
      boostValue: boostValueSelector(state),
      offsetValue: offsetValueSelector(state),
      tgpValue: tgpValueSelector(state),
      ocBinSources: ocBinSourcesSelector(state),
      baseSources: baseSourcesSelector(state),
      boostSources: boostSourcesSelector(state),
      source: sourcesSelector(state)
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      onChange: (value) => dispatch(updateValueAction(value))
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

export { default as Clock } from 'components/form/clock/index'
export {
  withConnect,
  withReducer
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id),
  withValidation(
    path,
    id,
    getValueSelector(path, id),
    [ UPDATE_VALUE ]
  )
)(Clock))
